import {useMutation} from "@tanstack/react-query";
import {exportRmaExcelFormApi} from "../../../../api/support/RMA";
import {downloadFile} from "../../../../util/FileDownload";
import {AxiosError} from "axios";
import {useModal} from "../../../../hooks";

const useDownloadExcelForm = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: () => exportRmaExcelFormApi(),
        onSuccess: (res) => {
            console.log(res);

            if (res instanceof Blob) {
                downloadFile(res, `RMA_엑셀_양식.xlsx`);
            }
        },
        onError: (error: AxiosError) => {
            console.log(error);
            if (error?.response?.data instanceof Blob) {
                error.response.data.text().then((value) => {
                    const obj = JSON.parse(value);
                    handleModal({
                        isOpen: true,
                        contents: obj?.msg,
                        type: "alert",
                    });
                });
            }
        },
    });
    return {mutate};
};

export default useDownloadExcelForm;
